<template>
  <div>
    <BaseSubtitle
      v-if="subtitle"
      :subtitle="subtitle"
    />
    <BaseTitle :small="small">{{ title }}</BaseTitle>
  </div>
</template>

<script>
import BaseTitle from './BaseTitle.vue';
import BaseSubtitle from './BaseSubtitle.vue';

export default {
  name: 'BaseTitleGroup',
  components: {
    BaseTitle,
    BaseSubtitle,
  },
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: null },
    small: { type: Boolean, default: false },
  },
};
</script>
